function _(e,n,a){e(3)()||Object.defineProperty(Object,"assign",{value:e(4),configurable:!0,enumerable:!1,writable:!0})}
//# sourceMappingURL=implement.min.js.map